import * as React from 'react';
import {useState} from 'react';
import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {localize} from 'commons/LocalizedText/LocalizedText';
import {TextFieldWithLabel} from 'commons/TextFieldWithLabel/TextFieldWithLabel';
import {FileDropZone} from 'commons/Upload/FileDropzone';
import {DialogWrapper} from 'commons/Dialog/DialogWrapper';
import {DialogType} from 'commons/Dialog/DialogTypes';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: '20px'
  }
}));

export const UploadLaboDocumentDialog = ({ open, onClose, fileName, onSubmit}) => {
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState('');
  const classes = useStyles();

  const handleDropZoneChange = file => (
    file && setFile(file)
  );

  const handleSubmit = () => {
    onSubmit(file, description);
    setDescription('');
    onClose();
  };

  const handleOnClose = () => {
    setDescription('');
    onClose();
  }

  return (
    <DialogWrapper
      onClose={handleOnClose}
      onSubmit={handleSubmit}
      open={open}
      title={localize("uploadLaboratoryFile")}
      variant={DialogType.CONFIRMATION}
    >
      <Grid alignItems={'center'} className={classes.content} container direction={'column'} justifyContent={'center'}>
        <Grid item>
          <FileDropZone onFileDrop={handleDropZoneChange} />
        </Grid>
        <Grid item>
          <TextFieldWithLabel label={localize("laboratoryFile.description")} onChange={setDescription} value={description}/>
        </Grid>
      </Grid>
    </DialogWrapper>
  );
};